import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CustomerMergeModel } from '../../Models/Models/Customer/CustomerMergeModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerMergeClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(firstCustomerId: number, secondCustomerId: number): Promise<CustomerMergeModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerMerge/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { firstCustomerId: firstCustomerId, secondCustomerId: secondCustomerId }

    return AjaxWrapper.get<CustomerMergeModel, any>(url, data);
  }
  public post(fromCustomerId: number, toCustomerId: number): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerMerge/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { fromCustomerId: fromCustomerId, toCustomerId: toCustomerId }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

